export default __webpack_public_path__ + "static/media/add_product-stap_02.3b14b881.png";